import {useState} from 'react';
import cn from 'classnames';
import MySaleCard from '../sales/card';
import useGetMyAdverisements from '../../../../services/hookService/getMyAdvertisements/useGetAdverisements';
import DotsLoading from '../../../../components/dotsLoading';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import useDeleteMyAdvertisment from '../../../../services/hookService/my-account/deleteMyAdvertisment/useDeleteMyAdvertisment';
import {DeleteBotoomSheet} from '../sales';
import NotFoundIcon from './../../../../assets/image/sponsor/404.svg';
import {useNavigate} from 'react-router-dom';
import useGetAllNotifications from '../../../../services/hookService/getAllNotification/useGetAllNotifications';

type RentType = 'give_rent' | 'get_rent';

const rentAdTypeMap: Record<RentType, 'advertisement' | 'requirement'> = {
  give_rent: 'advertisement',
  get_rent: 'requirement',
};

const Rents = () => {
  const navigate = useNavigate();
  const [rentType, setRentType] = useState<RentType>('give_rent');
  const {refetch: refetchAdNotificatons} = useGetAllNotifications();
  const {data, isLoading, refetch} = useGetMyAdverisements({filter: rentType});
  const [deleteItem, setDeleteItem] = useState<DeleteBotoomSheet>({
    isOpen: false,
    data: null,
  });
  const {mutate} = useDeleteMyAdvertisment({
    filter: 'advertisement',
    refetch: () => {
      refetch();
      refetchAdNotificatons();
      setDeleteItem({isOpen: false, data: null});
    },
  });
  const handeDeleteItem = (guid: string) => {
    mutate(guid);
  };

  return (
    <>
      <div className="flex justify-between gap-2 my-4">
        <button
          className={cn('py-2 w-1/2 rounded bg-gray-50 border-[1px]', {
            ' text-farm-shop-500 !border-farm-shop-500':
              rentType === 'give_rent',
            'text-gray-600 border-transparent': rentType !== 'give_rent',
          })}
          onClick={() => setRentType('give_rent')}
        >
          اجاره میدهم
        </button>
        <button
          className={cn('py-2 w-1/2 rounded bg-gray-50 border-[1px]', {
            'text-farm-shop-500 !border-farm-shop-500': rentType === 'get_rent',
            'text-gray-600 border-transparent': rentType !== 'get_rent',
          })}
          onClick={() => setRentType('get_rent')}
        >
          اجاره میگیرم
        </button>
      </div>
      {isLoading ? (
        <div className="my-auto">
          <DotsLoading />
        </div>
      ) : (
        <>
          {!data?.length ? (
            <div className="flex flex-col items-center justify-center px-3 text-sm text-gray-800 flex-1">
              <div className="flex flex-col justify-center items-center gap-6">
                <img src={NotFoundIcon} alt="not found" className="w-14" />
                <span>شما در این دسته آگهی‌ ثبت نکرده‌اید</span>
              </div>
              <button
                className="w-full text-farm-shop-500 border-[1px] border-solid !border-farm-shop-500 rounded bg-white py-3 mt-28"
                onClick={() => navigate('/advertisement-registeration')}
              >
                ثبت آگهی اجاره
              </button>
            </div>
          ) : (
            data?.map((item, index) => (
              <MySaleCard
                setDeleteItem={setDeleteItem}
                data={item}
                key={item.guid}
                type={rentAdTypeMap[rentType]}
              />
            ))
          )}
        </>
      )}
      <BottomSheet
        onDismiss={() => {
          setDeleteItem({isOpen: false, data: null});
        }}
        open={deleteItem.isOpen}
        blocking={true}
        className="transition ease-in-out delay-250 "
      >
        <div className="w-full flex flex-col gap-3 p-3">
          <div className="flex w-full justify-between">
            <p>حذف آگهی</p>
            <SpanIcon
              className="icon-nameClose-remove text-xl"
              onClick={() => setDeleteItem({isOpen: false, data: null})}
            />
          </div>
          <p>آیا اطمینان به حذف آگهی {deleteItem.data?.title} دارید؟</p>
          <div className="w-full flex justify-between gap-2 items-center text-md font-Medium">
            <button
              className="w-[70%] bg-red-500 h-[48px] text-white rounded-[8px]"
              onClick={() => handeDeleteItem(deleteItem.data?.guid || '')}
            >
              بله، حذف{' '}
            </button>
            <button
              className="w-[30%] text-farm-shop-500 h-[48px] border border-farm-shop-500 rounded-[8px]"
              onClick={() => setDeleteItem({isOpen: false, data: null})}
            >
              خیر
            </button>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default Rents;
